export default function addJwtToHttp(jwtInterceptorProvider, $httpProvider) {
  jwtInterceptorProvider.tokenGetter = ['localStorageService', function(localStorageService) {
    return localStorageService.get('token')
  }]
  $httpProvider.interceptors.push('jwtInterceptor')
}
